import { render, staticRenderFns } from "./AuctionRegisterAsBidder.vue?vue&type=template&id=ff956bee&scoped=true"
import script from "./AuctionRegisterAsBidder.vue?vue&type=script&lang=js"
export * from "./AuctionRegisterAsBidder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff956bee",
  null
  
)

export default component.exports